/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for create a day model
 * @export
 * @interface CreateDayModelRequest
 */
export interface CreateDayModelRequest {
    /**
     * Name of the day model
     * @type {string}
     * @memberof CreateDayModelRequest
     */
    dayModelName?: string;
}

/**
 * Check if a given object implements the CreateDayModelRequest interface.
 */
export function instanceOfCreateDayModelRequest(value: object): value is CreateDayModelRequest {
    return true;
}

export function CreateDayModelRequestFromJSON(json: any): CreateDayModelRequest {
    return CreateDayModelRequestFromJSONTyped(json, false);
}

export function CreateDayModelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDayModelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dayModelName': json['dayModelName'] == null ? undefined : json['dayModelName'],
    };
}

export function CreateDayModelRequestToJSON(json: any): CreateDayModelRequest {
    return CreateDayModelRequestToJSONTyped(json, false);
}

export function CreateDayModelRequestToJSONTyped(value?: CreateDayModelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayModelName': value['dayModelName'],
    };
}

